<template :key="rerenderKey">
  <ApolloQuery
    :query="require('@/graphql/queries/Company.gql')"
    :variables="{ rerenderKey: rerenderKey, id: $route.params.id, limit: $store.state.me.settings.lazy_load ? +this.limit: 0, skip: 0 }"
    @result="doneLoadingCompany"
    class="lsg-page lsg-trade__page trade_page"
  >
    <template slot-scope="{ result: { loading, error, data } }">
      <div class="ct__row" v-if="error">
        <div class="ct__col">
          <div class="ct__input">
            <label for="message">Ошибка:</label>
            <input type="text" :value="error.message" id="message" disabled />
          </div>
        </div>
      </div>
      <div class="loading apollo" v-else-if="loading">Загрузка</div>
      <div class="lsg-trade" v-else-if="data && data.Company">
        <div class="main__header">
          <div class="main__header__item left">
            <h1>
              {{ data.Company.name || title }}
              <span v-if="data.Company.sign && checkDate(data.Company.sign.createdAt)" v-tooltip:bottom="`До: ${dateEnd(new Date(data.Company.sign.createdAt))}`" style="color: #FF8000; cursor: pointer">&#10004;</span>
              <span v-if="data.Company.sign_date && Date.parse(data.Company.sign_date) && checkDate(data.Company.sign_date)" v-tooltip:bottom="`До: ${dateEnd(new Date(data.Company.sign_date))}`" style="color: #219653; cursor: pointer">&#10004;</span>
              <span v-if="!data.Company.sign && !data.Company.sign_date"></span>
              <span v-else-if="!((data.Company.sign && checkDate(data.Company.sign.createdAt)) || data.Company.sign_date || checkDate(data.Company.sign_date))" v-tooltip:bottom="'Срок согласия истёк'" style="color: #7a7a7a; cursor: pointer">&#10004;</span>
              <div
                v-if="data.Company.rating && data.Company.rating_date"
                class="company-rating"
                :class="{
                  'company-rating--green': data.Company.rating.includes('good'),
                  'company-rating--yellow': data.Company.rating.includes('average'),
                  'company-rating--red': data.Company.rating.includes('bad') || data.Company.rating.includes('negative'),
                }"
                v-tooltip="`Рейтинг ${data.Company.rating.includes(', ') ? `${data.Company.rating.split(', ')[1]} б.` : ''} от: ${ new Date(data.Company.rating_date).toLocaleDateString() }`"
              ></div>
              <div style="display: inline-block; margin-left: 15px" v-if="(['admin', 'headmanager'].includes($store.state.me.role) || $store.state.me._id === '6163eb7c2159179dc8203b70') && data.Company.inn" class="small-buttons">
                <a class="btn btn--small btn--white">
                  <i :class="{ 'rot': rating }" @click="updateRating(data.Company.inn)">
                    <RefreshIcon/>
                  </i>
                </a>
              </div>
            </h1>
          </div>
          <div class="main__header__item"></div>
          <div class="main__header__item right">
            <button
              v-if="data.Company.inn"
              class="btn"
              @click="$router.push({ name: 'sign', query: { inn: data.Company.inn, name: data.Company.name, id: data.Company._id } })"
            >
              Онлайн подписание
            </button>
            <div v-if="data.Company.diadoc">
              <DiadocIcon/>
            </div>
          </div>
        </div>
        <div class="main__content">
          <div class="crm">
            <aside class="crm__aside">
              <div class="workspace_left__header">
                <div class="workspace_left__row">
                  <div class="workspace_left__item">
                    <ul class="workspace_left__tags">
                      <li
                        :key="index"
                        v-for="(tag, index) in data.Company.tags"
                        :style="tag.id.includes('dept') ? 'color:red' : ''"
                      >
                        {{ tag.name }}
                      </li>
                    </ul>
                  </div>
                  <div class="workspace_left__created">
                    <span>{{ getDate(data.Company.createdAt) }}</span>
                  </div>
                </div>
                <div class="workspace_left__row">
                  <ul class="workspace_left__tags">
                    <li
                      :key="index"
                      v-for="(type, index) in data.Company.types"
                    >
                      <span
                        class='tag'
                        :class="`tag--${typeColor[type]}`"
                      >{{ type }}</span>
                    </li>
                  </ul>
                </div>
                <div class="workspace_left__row" v-if="data.Company.limit_summ">
                  <div class="workspace_left__item">
                    <div class="workspace_left__budget">
                      <span>Лимит СЭ</span>
                    </div>
                  </div>
                  <div class="workspace_left__item">
                    {{ data.Company.limit_count }} ед.
                  </div>
                  <div class="workspace_left__item">
                    {{ prettifyPrice(data.Company.limit_summ) }} руб.
                  </div>
                </div>
                <div class="workspace_left__row" v-if="data.Company.balance_summ">
                  <div class="workspace_left__item">
                    <div class="workspace_left__budget">
                      <span>Остаток СЭ</span>
                    </div>
                  </div>
                  <div class="workspace_left__item">
                    {{ data.Company.balance_count }} ед.
                  </div>
                  <div class="workspace_left__item">
                    {{ prettifyPrice(data.Company.balance_summ) }} руб.
                  </div>
                </div>
                <div class="workspace_left__row" v-if="data.Company.balance_summ">
                  <div class="workspace_left__item">
                    <div class="workspace_left__budget">
                      <span>Дата обновления</span>
                    </div>
                  </div>
                  <div class="workspace_left__item">
                    {{ new Date(+data.Company.period).toLocaleDateString() }}
                  </div>
                </div>
                <div class="workspace_left__row" v-if="data.Company.inn">
                  <div class="workspace_left__item">
                    <div class="workspace_left__budget">
                      <span>ИНН</span>
                      <strong>{{ data.Company.inn }}</strong>
                    </div>
                  </div>
                </div>
                <div
                  class="workspace_left__row"
                  v-for="phone in data.Company.phone"
                  :key="phone"
                >
                  <div class="workspace_left__item">
                    <div class="workspace_left__budget">
                      <span>Телефон</span>
                      <span>{{ phone }}</span>
                    </div>
                  </div>
                  <div class="workspace_left__item">
                    <i v-if="!callTimeout" @click="callPhone(phone)" style="cursor: pointer">
                      <PhoneOutIcon />
                    </i>
                    <i v-else style="cursor: wait">
                      X
                    </i>
                  </div>
                </div>
                <div class="workspace_left__row" v-if="data.Company.email">
                  <div class="workspace_left__item">
                    <div class="workspace_left__budget">
                      <span>Email</span>
                      <span>{{ data.Company.email }}</span>
                    </div>
                  </div>
                </div>
                <div class="workspace_left__row mb5">
                  <div class="workspace_left__item">
                    <span class="workspace_left__manager">{{
                      data.Company.responsible_user.name
                    }}</span>
                  </div>
                  <div class="workspace_left__item">
                    <a
                      href="#"
                      class="settings"
                      @click.prevent="
                        showCompanyDataModal(
                          $route.params.id,
                          data.Company,
                          'Company',
                          null
                        )
                      "
                    >
                      <NewSettingsIcon />
                    </a>
                  </div>
                </div>
                <div v-if="calculation" class="workspace_left__row">
                  <div class="workspace_left__item">
                    <span style="color: green">Рассчитываем...</span>
                  </div>
                </div>
                <div v-if="($store.state.me.role === 'admin' || $store.state.me._id === '6163eb7c2159179dc8203b70' || $store.state.me.role === 'headmanager') && data.Company.inn && !isForgottenClient(data.Company.tags)" class="small-buttons">
                    <a @click="updatePartner(data.Company.inn)" class="btn btn--small btn--white limit-update">
                      <i>
                        <RefreshIcon/>
                      </i>
                    </a>
                  </div>
                <!-- <div>
                  <router-link :to="{ name: 'sign', params: { inn: data.Company.inn } }" >Онлайн подписание</router-link>
                </div> -->
                <div class="workspace_left__row" v-if="$store.state.me.role !== 'partner' && isForgottenClient(data.Company.tags)">
                  <div class="workspace_left__item">
                    <div class="workspace_left__budget">
                      <div class="btn" @click="pickUpClient(data.Company._id)">Забрать себе</div>
                    </div>
                  </div>
                  <div v-if="$store.state.me.role === 'admin' && data.Company.inn" class="small-buttons">
                    <a @click="updatePartner(data.Company.inn)" class="btn btn--small btn--white" href="#">
                      <i>
                        <RefreshIcon/>
                      </i>
                    </a>
                  </div>
                </div>
              </div>
              <div class="workspace_left__row accordion">
                <div
                  v-if="data.Company.holding && data.Company.holding.companies && data.Company.holding.companies.length"
                  class="workspace_body__item accordion__item"
                >
                  <h3
                    :class="{
                      trade_content__title: true,
                      active: holding_dropdown,
                    }"
                    @click="holding_dropdown = !holding_dropdown"
                  >
                    <span>{{ data.Company.holding.name }}</span>
                    <ArrowDown />
                  </h3>
                  <div class="accordion__content" v-if="holding_dropdown">
                    <ul class="tc">
                      <li
                        v-for="company in data.Company.holding.companies"
                        :key="company.id"
                      >
                        <ul class="tc__list">
                          <li>
                            <router-link
                              :to="{
                                name: 'company',
                                params: { id: company.id },
                              }"
                              class="tc__list__title"
                              >{{ company.name }}</router-link>
                            <span class="tc__list__subtitle"
                              >ИНН {{ company.inn || '-' }}</span
                            >
                            <i
                              @click="
                                unbindHolding(company.id)
                              "
                            >
                              <DeleteIcon />
                            </i>
                          </li>
                        </ul>
                      </li>
                    </ul>
                    <div class="tc__more">
                      <a
                        href="#"
                        @click.prevent="showHolding(data.Company.holding.id)"
                      >
                        + еще компания
                      </a>
                    </div>
                  </div>
                </div>
                <div v-else class="workspace_body__item accordion__item">
                  <h3
                    :class="{
                      trade_content__title: true
                    }"
                    @click="showHolding(null)"
                  >
                    <span>Добавить в холдинг</span>
                  </h3>
                </div>
                <div class="workspace_body__item accordion__item">
                  <h3
                    :class="{
                      trade_content__title: true,
                      active: contact_dropdown,
                    }"
                    @click="contact_dropdown = !contact_dropdown"
                  >
                    <span>Контакты</span>
                    <ArrowDown />
                  </h3>
                  <div class="accordion__content" v-if="contact_dropdown">
                    <ul class="tc">
                      <li
                        v-for="contact in data.Company.contacts"
                        :key="contact._id"
                      >
                        <ul class="tc__list">
                          <li>
                            <router-link
                              :to="{
                                name: 'contact',
                                params: { id: contact._id },
                              }"
                              class="tc__list__title"
                              >{{ contact.name }}</router-link
                            >
                            <span
                              class="tc__list__subtitle"
                              v-if="contact.post"
                              >{{ contact.post }}</span
                            >
                            <i
                              @click="
                                showContactDataModal(
                                  data.Company._id,
                                  contact,
                                  'update'
                                )
                              "
                            >
                              <NewSettingsIcon />
                            </i>
                            <i
                              @click="
                                hideContact(contact)
                              "
                            >
                              <DeleteIcon />
                            </i>
                          </li>
                          <li v-if="contact.phone.length">
                            <span class="tc__list__title">Телефон</span>
                            <span class="tc__list__subtitle">{{
                              contact.phone[0]
                            }}</span>
                            <i v-if="!callTimeout" @click="callPhone(contact.phone[0])">
                              <PhoneOutIcon />
                            </i>
                            <i v-else style="cursor: wait">
                              X
                            </i>
                          </li>
                          <li v-if="contact.email">
                            <span class="tc__list__title">Email</span>
                            <span class="tc__list__subtitle">{{
                              contact.email.split(";").join(", ")
                            }}</span>
                            <i></i>
                          </li>
                        </ul>
                      </li>
                    </ul>
                    <div class="tc__more">
                      <a
                        href="#"
                        @click.prevent="
                          showContactDataModal(
                            data.Company._id,
                            null,
                            'add'
                          )
                        "
                        >+ еще контакт</a
                      >
                    </div>
                  </div>
                </div>
                <div class="workspace_body__item accordion__item">
                  <h3
                    :class="{
                      trade_content__title: true,
                      active: lead_dropdown,
                    }"
                    @click="lead_dropdown = !lead_dropdown"
                  >
                    <span>Сделки</span>
                    <ArrowDown />
                  </h3>
                  <div class="accordion__content" v-if="lead_dropdown">
                    <ul class="tc">
                      <li
                        v-for="lead in data.Company.leads"
                        :key="lead._id"
                      >
                        <ul class="tc__list">
                            <li>
                            <router-link
                              :to="{
                                name: 'trade',
                                params: { id: lead.id },
                              }"
                              class="tc__list__title"
                              >{{ lead.name || data.Company.name }}</router-link>
                            <span
                              class="tc__list__subtitle"
                              >{{ getStatus(lead.status) }}</span
                            >
                          </li>
                        </ul>
                      </li>
                    </ul>
                    <div class="tc__more">
                      <a
                        v-if="!isCreateLead"
                        href="#"
                        @click="addCompanyInLead(data.Company._id, data.Company.name)"
                      >+ новая сделка</a>
                    </div>
                  </div>
                </div>
                <div class="workspace_body__item accordion__item" v-if="data.Company.files && data.Company.files.length">
                  <h3
                    :class="{
                      trade_content__title: true,
                      active: docs_dropdown,
                    }"
                    @click="docs_dropdown = !docs_dropdown"
                  >
                    <span>Документы</span>
                    <ArrowDown />
                  </h3>
                  <div class="accordion__content" v-if="docs_dropdown">
                    <ul class="tc">
                      <li
                        v-for="(category, index) in groupBy(
                            data.Company.files,
                            'view'
                          )"
                          :key="index"
                      >
                        <ul class="tc__list">
                          <li><strong>{{ category.title }}</strong></li>
                          <li
                            :key="index"
                            v-for="(doc, index) in category.items"
                          >
                            <span class="tc__list__title">{{ doc.name }}</span>
                            <a class="tc__list__subtitle" :href="'https://' + doc.path" target="_blank" download>Скачать ({{ doc.ext }})</a>
                          </li>
                        </ul>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </aside>
            <LsgNotes
              v-if="data && data.Company"
              :key="noteRerenderKey"
              :isRightPage="true"
              elementType="Company"
              :elementId="data.Company._id"
              :notes="companyData.notes || []"
              :tasks="companyData.tasks || []"
              :activeTasks="companyData.activeTasks || []"
              :position="position1"
              :onLoading="onLoading"
              :elementEmail="data.Company.email"
              v-bind:position1.sync="position1"
            ></LsgNotes>
          </div>
        </div>
      </div>
    </template>
  </ApolloQuery>
</template>

<script>
import _ from 'lodash'
import moment from 'moment'
// import MAKE_CALL from '@/graphql/mutations/MakeCall.gql'
import ArrowDown from '@/components/svg/arrow_down'
import LsgNotes from '@/components/ui/LsgNotes'
import ADD_LEAD from '@/graphql/mutations/AddLead.gql'
import GraphQLHelper from '@/helpers/GraphQLHelper'
import NewSettingsIcon from '../../components/svg/new/Settings'
import PhoneOutIcon from '../../components/svg/new/PhoneOutIcon'
import UPDATE_COMPANY from '@/graphql/mutations/UpdateCompany.gql'
import UPDATE_PARTNER from '@/graphql/mutations/UpdatePartnerLimit.gql'
import UPDATE_RATING from '@/graphql/mutations/UpdateRating.gql'
import RefreshIcon from '@/components/svg/RefreshIcon'
import DiadocIcon from '@/components/svg/DiadocIcon'
import HIDE_CONTACT from '@/graphql/mutations/HideContact.gql'
import UNBIND_HOLDING from '@/graphql/mutations/UnbindHolding.gql'
import DeleteIcon from '@/components/svg/DeleteIcon.vue'

// import axios from 'axios'

const _graphQlHelper = new GraphQLHelper()

export default {
  name: 'Company',
  props: {
    id: {
      type: String,
      required: true
    }
  },
  data: () => {
    return {
      callTimeout: false,
      rating: false,
      noteRerenderKey: 0,
      lastPosition: 0,
      position1: 1000000,
      title: 'Наименование',
      main_dropdown: false,
      contact_dropdown: true,
      lead_dropdown: false,
      holding_dropdown: false,
      docs_dropdown: false,
      isCreateContact: false,
      isCreateLead: false,
      leftSwitcher: false,
      calculation: false,
      companyData: null,
      onLoading: true,
      limit: 10,
      typeColor: {
        'Лизингополучатель': 'blue',
        'Поставщик': 'green',
        'Поручитель': 'orange',
        'Агент': 'yellow'
      },
      links: [
        {
          name: 'Главная',
          route: 'home'
        },
        {
          name: 'Компании',
          route: 'companies'
        },
        {
          name: 'Редактирование компании'
        }
      ]
    }
  },
  components: {
    ArrowDown,
    LsgNotes,
    PhoneOutIcon,
    RefreshIcon,
    NewSettingsIcon,
    DiadocIcon,
    DeleteIcon
  },
  computed: {
    rerenderKey () {
      return this.$store.state.data.companies.rerenderKey
    }
  },
  methods: {
    showHolding (id) {
      this.$store.commit('setHoldingData', id)
    },
    async unbindHolding (id) {
      this.$apollo
        .mutate({
          mutation: UNBIND_HOLDING,
          variables: {
            input: {
              company_id: id
            }
          },
          update: (_, { data }) => {
            if (data && data.unbindHolding) {
              this.$store.commit('incrementCompanyRerenderKey')
              this.$notify({
                group: 'lsg-notify',
                text: `Компания ${data.unbindHolding.name} удалена из холдинга`
              })
            }
          }
        })
    },
    hideContact (contact) {
      this.$apollo
        .mutate({
          mutation: HIDE_CONTACT,
          variables: {
            id: contact._id
          },
          update: (_, { data }) => {
            if (data && data.hideContact) {
              this.$store.commit('incrementCompanyRerenderKey')
              this.$notify({
                group: 'lsg-notify',
                text: `Контакт ${data.hideContact.name} скрыт`
              })
            }
          }
        })
    },
    dateEnd (date) {
      date.setDate(date.getDate() + 180)
      return date.toLocaleDateString()
    },
    checkDate (date) {
      try {
        return new Date(date).setDate(new Date(date).getDate() + 180) > new Date()
      } catch (e) {
        return false
      }
    },
    async doneLoadingCompany ({ data }) {
      this.companyData = data.Company
      if ((this.companyData._allNotesMeta + this.companyData.tasks.length) <= this.limit) this.onLoading = false
      this.$nextTick(() => {
        this.noteRerenderKey++
      })
    },
    async updatePartner (inn) {
      this.calculation = true
      await this.$apollo
        .mutate({
          mutation: UPDATE_PARTNER,
          variables: { inn },
          update: (store, { data }) => {
            this.calculation = false
            if (data) {
              this.$router.go()
            } else {
              this.$notify({
                group: 'lsg-notify',
                text: 'Расчитано'
              })
            }
          }
        })
        .catch((error) => {
          this.calculation = false
          _graphQlHelper.graphQLErrorMessages(error).forEach((item) => {
            this.$notify({
              group: 'lsg-notify',
              text: item
            })
            this.$notify({
              group: 'lsg-notify-support',
              title: 'Сообщить в поддержку',
              text: `Нажав на это сообщение, вы отправите отчёт об ошибке в тех.поддержку`,
              type: 'info',
              closeOnClick: true,
              data: {
                info: {
                  project: 'Личный кабинет Leasing-trade',
                  name: this.$store.state.me.name,
                  email: this.$store.state.me.email,
                  group_id: this.$store.state.me.group.id,
                  role: this.$store.state.me.role,
                  localTime: new Date(),
                  system: navigator.userAgent,
                  url: window.location.href,
                  window: `${window.window.screen.availWidth}px ${window.window.screen.availHeight}px`,
                  error: item,
                  comment: 'Ошибка при расчёте лимита в компании'
                },
                style: 'cursor: pointer'
              }
            })
          })
        })
    },
    async updateRating (inn) {
      this.rating = true
      await this.$apollo
        .mutate({
          mutation: UPDATE_RATING,
          variables: { inn },
          update: (store, { data }) => {
            if (data) {
              this.$router.go()
            } else {
              this.$notify({
                group: 'lsg-notify',
                text: 'Не удалось обновить рейтинг'
              })
            }
          }
        })
        .catch((error) => {
          this.rating = false
          _graphQlHelper.graphQLErrorMessages(error).forEach((item) => {
            this.$notify({
              group: 'lsg-notify',
              text: item
            })
            this.$notify({
              group: 'lsg-notify-support',
              title: 'Сообщить в поддержку',
              text: `Нажав на это сообщение, вы отправите отчёт об ошибке в тех.поддержку`,
              type: 'info',
              closeOnClick: true,
              data: {
                info: {
                  project: 'Личный кабинет Leasing-trade',
                  name: this.$store.state.me.name,
                  email: this.$store.state.me.email,
                  group_id: this.$store.state.me.group.id,
                  role: this.$store.state.me.role,
                  localTime: new Date(),
                  system: navigator.userAgent,
                  url: window.location.href,
                  window: `${window.window.screen.availWidth}px ${window.window.screen.availHeight}px`,
                  error: item,
                  comment: 'Ошибка при обновлении рейтинга в компании'
                },
                style: 'cursor: pointer'
              }
            })
          })
        })
    },
    isForgottenClient (tags) {
      let checkTag = false
      tags.forEach(tag => {
        if (tag.name === 'Забытый клиент') checkTag = true
      })
      return checkTag
    },
    async pickUpClient (companyId) {
      await this.$apollo
        .mutate({
          mutation: UPDATE_COMPANY,
          variables: {
            input: {
              id: companyId,
              responsible_user_id: this.$store.state.me._id
            }
          },
          update: (store, { data }) => {
            if (data) {
              this.$notify({
                group: 'lsg-notify',
                text: 'Тег "Забытый клиент" снят'
              })
              this.$store.commit('incrementCompanyRerenderKey')
            }
          }
        })
        .catch((error) => {
          _graphQlHelper.graphQLErrorMessages(error).forEach((item) => {
            this.$notify({
              group: 'lsg-notify',
              text: item
            })
            this.$notify({
              group: 'lsg-notify-support',
              title: 'Сообщить в поддержку',
              text: `Нажав на это сообщение, вы отправите отчёт об ошибке в тех.поддержку`,
              type: 'info',
              closeOnClick: true,
              data: {
                info: {
                  project: 'Личный кабинет Leasing-trade',
                  name: this.$store.state.me.name,
                  email: this.$store.state.me.email,
                  group_id: this.$store.state.me.group.id,
                  role: this.$store.state.me.role,
                  localTime: new Date(),
                  system: navigator.userAgent,
                  url: window.location.href,
                  window: `${window.window.screen.availWidth}px ${window.window.screen.availHeight}px`,
                  error: item,
                  comment: 'Ошибка при изменении отвественного в компании'
                },
                style: 'cursor: pointer'
              }
            })
          })
        })
    },
    groupBy (array, string) {
      let group = _.groupBy(array, string)
      return Object.keys(group).map((key) => ({
        title: key,
        items: group[key]
      }))
    },
    prettifyPrice (price) {
      return Number(price).toLocaleString('ru', {
        maximumFractionDigits: 2
      })
    },
    async addCompanyInLead (companyId, companyName) {
      this.isCreateLead = true
      await this.$apollo
        .mutate({
          mutation: ADD_LEAD,
          variables: {
            input: {
              status: 'first',
              company_id: companyId,
              name: companyName
            }
          },
          update: (store, { data: { addLead } }) => {
            if (addLead && addLead._id) {
              this.$router.push({ name: 'trade', params: { id: addLead._id } })
            }
          }
        })
        .catch((error) => {
          _graphQlHelper.graphQLErrorMessages(error).forEach((item) => {
            this.$notify({
              group: 'lsg-notify',
              text: item
            })
            this.$notify({
              group: 'lsg-notify-support',
              title: 'Сообщить в поддержку',
              text: `Нажав на это сообщение, вы отправите отчёт об ошибке в тех.поддержку`,
              type: 'info',
              closeOnClick: true,
              data: {
                info: {
                  project: 'Личный кабинет Leasing-trade',
                  name: this.$store.state.me.name,
                  email: this.$store.state.me.email,
                  group_id: this.$store.state.me.group.id,
                  role: this.$store.state.me.role,
                  localTime: new Date(),
                  system: navigator.userAgent,
                  url: window.location.href,
                  window: `${window.window.screen.availWidth}px ${window.window.screen.availHeight}px`,
                  error: item,
                  comment: 'Ошибка при прикреплении сделки к компании'
                },
                style: 'cursor: pointer'
              }
            })
          })
        })
    },
    getDate (datetime) {
      return datetime ? moment(String(datetime)).format('DD.MM.YYYY') : ''
    },
    getStatus (status) {
      if (this.$store.state.leadStatusListClear) {
        for (let i = 0; i < this.$store.state.leadStatusListClear.length; i++) {
          if (this.$store.state.leadStatusListClear[i].value === status) {
            return this.$store.state.leadStatusListClear[i].title
          }
        }
      }
    },
    showContactDataModal (companyId, data, type) {
      this.$store.state.data.trades.contactDataModal = !this.$store.state.data
        .trades.contactDataModal
      this.$store.state.data.trades.contactDataModalProps.companyId = companyId
      this.$store.state.data.trades.contactDataModalProps.data = data
      this.$store.state.data.trades.contactDataModalProps.type = type
    },
    showCompanyDataModal (elementId, data, elementType, isCanceled) {
      this.$store.state.data.trades.companyDataModal = !this.$store.state.data
        .trades.companyDataModal
      this.$store.state.data.trades.companyDataModalProps.companyId = elementId
      this.$store.state.data.trades.companyDataModalProps.data = data
      this.$store.state.data.trades.companyDataModalProps.type = elementType
      this.$store.state.data.trades.companyDataModalProps.type = isCanceled
    },
    async callPhone (phone) {
      if (!phone || !this.$store.state.me.workphone) {
        this.$notify({
          group: 'lsg-notify',
          text: 'Не указан телефон'
        })
        return
      }
      const callWindow = window.open(`http://192.168.10.3/amocrm/amocrm.php?_login=amocrm&_secret=mWYd1BU9hmWuezov&_action=call&to=${phone}&as=Amocrm&from=${this.$store.state.me.workphone}&rand=0.9550694509986963`)
      setTimeout(() => {
        callWindow.close()
      }, 1_000)
    }
  },
  watch: {
    position1: function () {
      this.limit = this.limit + 10
    }
  }
}
</script>

<style lang="stylus">
.modal__attention__textarea > textarea {
  max-width 300px
}

.modal__attention__origin {
  display grid
  grid-template-columns 1fr 1fr
  grid-column-gap 10px
  grid-row-gap 10px
  width 100%
  margin-bottom 20px

  +below(768px) {
    grid-template-columns 1fr
  }
}

.modal__origin__item {
  display flex
  align-items center
  flex-wrap nowrap
}

.modal__origin__checkbox {
  margin-right 10px
  max-width 15px
  max-height 15px
}

.modal__origin__label {
  display inline-block
  white-space nowrap
  color black
}

.item__switch {
  display flex
  flex-direction row
  flex-wrap wrap
  justify-content center
  align-items center
  margin 0 10px

  > .switcher {
    margin-bottom -5px
    margin-right 10px
  }

  > span {
    align-text center

    +below(768px) {
      display none
    }
  }
}

.lsg-trade {
  width: 100%;
}

.crm {
  display: flex;
  align-items: flex-start;
  justify-content: flex-start;
  margin: 0 -16px;
  width: 100%;

  +below(768px) {
    width: calc(100% + 42px);
  }

  +below(560px) {
    flex-direction: column;
  }

  +below(540px) {
    margin-bottom: 60px;
  }

  &__div {
    margin: 0 4px;
  }

  &__main {
    display: flex;
    flex-direction: column;
    padding: 20px;
  }

  &__aside {
    display: flex;
    flex-direction: column;
    max-width: 420px;
    width: 100%;
    height: calc(100vh - 195px);
    margin: 0 16px;
    background: $white;
    border: 1px solid rgba($darkgray, 0.3);
    box-sizing: border-box;
    box-shadow: 0 7px 30px rgba($black, 0.06);
    border-radius: 10px;
    padding: 20px;
    overflow-y: auto;

    +below(768px) {
      max-width: 50%;
      margin-right: 0;
    }

    +below(560px) {
      max-width: 100%;
      height: auto;
      margin: 0 16px;
      box-sizing: border-box;
      width: auto;
    }
  }

  &__notes {
    display: flex;
    flex-direction: column;
    align-items: stretch;
    max-width: calc(100% - 420px);
    width: 100%;
    margin: 0 -16px;
    position: relative;
    padding: 0 11px;

    +below(768px) {
      max-width: 50%;
      margin: 0;
      padding: 0;
    }

    +below(560px) {
      max-width: 100%;
    }

    &__overdue {
      display: flex;
      align-items: flex-start;
      justify-content: flex-start;
      padding: 10px 32px;
      absolute: left top;
      width calc(100% - 28px)
      background: $white;
      border-top-left-radius: 10px;
      border-top-right-radius: 10px;
      transform: translateY(-100%);
      margin: 0 14px;
      border-bottom: 1px solid $darkgray;
      box-shadow: 0 7px 30px rgba($black, 0.06);
      z-index: 1;

      +below(560px) {
        display: none;
      }

      &__icon {
        width: 20px;
        height: 20px;
        display: flex;
        align-items: center;
        justify-content: center;

        svg {
          width: 100%;
          height: 100%;
        }
      }

      &__div {
        margin-left: 20px;
        margin-right: 5px;
      }

      &__list {
        padding: 0;
        font-weight: 500;
        font-size: 11px;
        line-height: 13px;
        color: $c7A;
        margin: -4px 0 -4px 20px;

        li {
          margin: 4px 0;
        }
      }
    }

    &__send {
      background: none;
      border: none;
      absolute: right 16px bottom 10px;
      display: flex;
      align-items: center;
      justify-content: center;
      cursor: pointer;
    }

    &__drag {
      background: none;
      border: none;
      absolute: right 60px bottom 0;
      display: flex;
      align-items: center;
      justify-content: center;
      cursor: pointer;
      margin: 0 !important
    }

    &__cancel {
      absolute: right 64px bottom 19px;
      font-weight: 500;
      font-size: 12px;
      line-height: 15px;
      color: $blue;
    }

    &__div {
      font-weight: 500;
      font-size: 12px;
      line-height: 15px;
      color: $c4E555A;
    }

    &__list {
      list-style: none;
      display: flex;
      flex-direction: column;
      align-items: stretch;
      width: 100%;
      height: calc(100vh - 350px);
      overflow: hidden;
      padding: 0 16px 200px;
      margin-bottom: 8px;

      +below(560px) {
        height: auto;
        margin-top: 24px;
        padding-bottom: 10px;
      }
    }

    &__form {
      background: $white;
      border: 1px solid $darkgray;
      box-sizing: border-box;
      border-radius: 10px;
      margin: 0 16px;
      position: relative;

      &--deminished {
        margin: 0;
        border: 0;

        .mx-input {
          background: transparent !important;
        }
      }

      &__header {
        display: flex;
        align-items: center;
        justify-content: flex-start;
        flex-wrap: wrap;
        padding: 0 14px;
        // height 1rem

        & .mx-input-wrapper input {
          background: transparent !important;
        }
      }

      &__body {
        textarea {
          border: none;
          resize: none;
          height: 100%;
          display: flex;
          border-radius: 0 0 10px 10px;
        }
      }

      select {
        border: none;
        font-weight: 500;
        font-size: 12px;
        line-height: 15px;
        color: $blue;
        width: fit-content !important;
        appearance: none;
        background: none;
        padding: 6px 8px;
        height: auto;
        box-shadow: none !important;
        outline: none !important;
      }

      .mx-datepicker {
        width: auto;
      }

      .mx-input {
        border: none !important;
        height: auto !important;
        font-weight: 500 !important;
        font-size: 12px !important;
        line-height: 15px !important;
        color: $blue !important;
        width: fit-content !important;
        box-shadow: none !important;
      }

      .vs--single.vs--open {
        .vs__selected {
          position: relative;
        }
      }

      .v-select {
        width: fit-content;

        .vs__dropdown-toggle {
          padding: 0;
          border: none;
        }

        .vs__selected {
          font-weight: 500;
          font-size: 12px;
          line-height: 15px;
          color: $blue;
        }

        .vs__search {
          padding: 0;
          margin: 0;
          height: 100%;
        }
      }
    }

    &__type {
      display: inline-flex;
      position: relative;
      user-select: none;

      &__selected {
        font-weight: 500;
        font-size: 12px;
        line-height: 15px;
        color: $blue;
        padding: 6px 8px;
        cursor: pointer;
      }

      &__list {
        absolute: left bottom;
        padding: 0;
        transform: translateY(100%);
        background: $white;
        border: 1px solid $pinky;
        box-sizing: border-box;
        box-shadow: 0 10px 30px rgba($c4E555A, 0.17);
        border-radius: 0 0 10px 10px;
        font-weight: 500;
        font-size: 12px;
        line-height: 15px;
        z-index: 999;
        overflow: hidden;

        li {
          padding: 6px 8px;
          width: 100%;
          color: $c4E555A;
          background: $white;
          cursor: pointer;

          &:hover {
            background: $orange;
            color: $white;
          }
        }
      }
    }
  }

  &__note {
    background: $white;
    border: 1px solid rgba($darkgray, 0.3);
    box-sizing: border-box;
    box-shadow: 0 7px 30px rgba($black, 0.06);
    border-radius: 10px;
    padding: 10px 20px;
    width: 100%;
    margin-bottom: 8px;
    flex-shrink: 0;

    &__close-outdated {
      display: flex;

      button {
        margin-left: 20px;
      }
    }

    &--red {
      background: rgba($red, 0.1);
      border: 1px solid rgba($darkgray, 0.3);
      width: calc(100% - 28px);
      margin: 10px auto 8px;

      .crm__note__date, .crm__note__manager, .crm__div, .crm__note__responsible {
        color: $red;
        font-weight: bold;
      }

      .crm__note__icon svg {
        path[stroke] {
          stroke: $red;
        }

        path[fill] {
          fill: $red;
        }
      }
    }

    &__header {
      display: flex;
      align-items: center;
      justify-content: space-between;
      font-weight: 500;
      font-size: 11px;
      line-height: 13px;
      color: $c7A;
      padding-bottom: 10px;
      border-bottom: 1px solid $pinky;
      margin-bottom: 10px;

      &__info {
        display: flex;
        align-items: center;
        justify-content: flex-start;
        flex-wrap: wrap;
      }

      &__actions {
        display: flex;
        align-items: center;
        margin: 0 -6px;
      }
    }

    &__action {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 22px;
      height: 22px;
      padding: 0 6px;

      svg {
        width: 100%;
        height: auto;
      }
    }

    &__icon {
      width: 20px;
      height: 20px;
      display: flex;
      align-items: center;
      justify-content: center;
      margin-right: 15px;

      svg {
        width: 100%;
        height: 100%;

        path[stroke] {
          stroke: $orange;
        }

        path[fill] {
          fill: $orange;
        }
      }

      &--green {
        svg {
          path[stroke] {
            stroke: $darkgreen;
          }

          path[fill] {
            fill: $darkgreen;
          }
        }
      }
    }

    &__date {
      margin-right: 15px;
    }

    &__body {
      display: flex;
      flex-direction: column;
      justify-content: stretch;
      align-items: stretch;
      font-size: 14px;

      span, strong, p {
        font-size: 14px;
      }

      p .crm__note__text {
        margin-right: 4px;
      }
    }

    &__text {
      font-size: 0.9em;
      line-height: normal;
    }

    &__footer {
      padding-top: 10px;
      border-top: 1px solid $pinky;
      margin-top: 10px;
      display: flex;
      align-items: center;
      justify-content: flex-start;
      font-weight: 500;
      font-size: 11px;
      line-height: 13px;
      color: $c7A;

      .btn {
        padding: 6px 8px;
        min-height: auto;
        margin: 0 16px;
        border-radius: 5px;
      }
    }
  }
}
button[disabled] {
  border 1px solid #999999
  background-color #cccccc
  color #666666
  pointer-events none
}
.lead-rating, .lead-accreditation, .lead-liquidity {
  display: inline-block;
  height: 30px;
  width: 30px;
  margin-left: 10px;

    /* padding: 5px; */
  > svg {
    height: inherit;
    width: inherit;
    color: #231F20;
    fill: #231F20;

    path[stroke-width] {
      stroke-width 5
    }

    path[stroke] {
      stroke #231F20
    }

    path[fill] {
      fill #231F20
    }
  }
}
.lead-rating--green, .lead-accreditation--green, .lead-liquidity--green {
  > svg {
    color: #219653;
    fill: #219653;
  }
}
.lead-accreditation--red, .lead-rating--red, .lead-liquidity--red {
  > svg {
    color: #FF0000;
    fill: #FF0000;
  }
}
.lead-accreditation--yellow, .lead-rating--yellow, .lead-liquidity--yellow {
  > svg {
    color: #FF8000;
    fill: #FF8000;
  }
}
.guarantor-icon {
  svg {
    path[stroke] {
      stroke $black !important
    }

    path[fill] {
      fill $black !important
    }
  }
}
</style>

<style lang="stylus" >
  @media only screen and (max-width: 380px) {
    .limit-update {
      padding: 0 !important;
    }
  }
  .company-rating {
    display: inline-block;
    border-radius: 50%;
    height: 15px;
    width: 15px;
    margin: auto 0 3px 15px;
     /* padding: 5px; */
  }
  .company-rating--green {
    background: #219653;
    box-shadow: inset 0 0 0.5em 0 #219653, 0 0 0.5em 0 #219653
  }
  .company-rating--red {
    background: #FF0000;
    box-shadow: inset 0 0 0.5em 0 #FF0000, 0 0 0.5em 0 #FF0000
  }
  .company-rating--yellow {
    background: #FF8000;
    box-shadow: inset 0 0 0.5em 0 #FF8000, 0 0 0.5em 0 #FF8000
  }
  .rot {
    animation: 1s linear 0s normal none infinite running rot;
    -webkit-animation: 1s linear 0s normal none infinite running rot;
    transform-origin: 50% 50%
  }
  @keyframes rot {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }
  @-webkit-keyframes rot {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }
</style>
